"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateKey = generateKey;
exports.toId = toId;
exports.isLocalIdEqualTo = isLocalIdEqualTo;
exports.getLocalType = getLocalType;
exports.TYPE = exports.ID = void 0;
var ID = 'id';
exports.ID = ID;
var TYPE = 'type';
exports.TYPE = TYPE;

function generateKey(type) {
  return "interaction-" + type;
}

function toId(type, objectType, subjectId) {
  return type + "-" + objectType + "-" + subjectId;
}

function isLocalIdEqualTo(key, id, localAccessor) {
  var storage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : localStorage;
  var data = localAccessor(storage, key);
  return !!data && data[ID] === id;
}

function getLocalType(type, objectType, subjectId, localAccessor) {
  var storage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : localStorage;
  var data = localAccessor(storage, generateKey(type));

  if (data && data[ID] === toId(type, objectType, subjectId)) {
    return data[TYPE];
  }

  return false;
}